import React from 'react'

const affiliatePortalRoutes = [
    {
        key: 'affiliate.dashboard',
        path: '/dashboard',
        component: React.lazy(() => import('views/affiliate-portal/Dashboard')),
        authority: [],
    },
]

export default affiliatePortalRoutes
